// Generate code from clean architecture template

import { CourseLineEntity } from '../entities';
import { CourseLineRepository } from '../ports/repositories';

export class FindCourseLineUsecase {
  constructor(private readonly repo: CourseLineRepository) {}

  async run(id: string): Promise<CourseLineEntity> {
    const data = await this.repo.getDetailCourseLine(id);
    return data;
  }
}
